import { Button, Divider, Row, Table } from 'antd';
import { useIntl } from 'umi';
import { useDrawerWidth } from '@/components/LeadSource/context';
import { useEffect } from 'react';
import { F } from '@/utils/intl';

const PreviewParsedDataTableSegment = ({
  mappedData,
  previewColumns,
  sendDataToServer,
  stepLoading,
  onClose,
  prevStep,
  errorObject,
}) => {
  const intl = useIntl();
  const {drawerWidth, setDrawerWidth} = useDrawerWidth()
  useEffect(() => {
    setDrawerWidth(1200);
    return () => {
      setDrawerWidth(800);
    };
  }, []);
  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 25,
        }}
      >
        <Button type="link" style={{ color: '#27AE9D' }} onClick={prevStep}>
          <F
            id={'pages.leadsources.sepratorProblem'}
            defaultMessage={'Is there a problem with csv seperator?'}
          />
        </Button>
      </div>

      <Table
        dataSource={mappedData?.slice(0, 100)} // Show first 100 rows for preview
        columns={previewColumns}
        pagination={{defaultPageSize: 10}}
        scroll={{ y: 400 }}
        size={"small"}
        rowKey={(record, index) => index}
        bordered
      />
      {(mappedData || [])?.length > 100 && (
        <p style={{ marginTop: '10px' }}>Showing first 100 of {mappedData?.length} records.</p>
      )}
      <Divider />
      <Row style={{ justifyContent: 'flex-end' }}>
        <Button type="default" onClick={onClose} style={{ margin: '0 8px' }}>
          <F id="common.actions.cancel" />
        </Button>

        <Button style={{ margin: '0 8px' }} onClick={prevStep}>
          <F id="pages.common.previous" />
        </Button>

        <Button
          type="primary"
          style={{ margin: '0 8px' }}
          onClick={sendDataToServer}
          loading={stepLoading}
        >
          <F id="pages.leadsources.sendDataToServer" defaultMessage="Send Data to Server" />
        </Button>
      </Row>
    </div>
  );
};

export default PreviewParsedDataTableSegment;
